import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";

export const styles = StyleSheet.create({
  header: {
    // margin: 10,
    // padding: 10,
    // width: "95%",
    marginBottom: 30,
  },
  footer: {
    // margin: 10,
    // padding: 10,
    // width: "100%",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
  },
  footerImage: {
    width:"100%"
  },
  page: {
    // display: "flex",
    //   justifyContent: 'flex-start',
    fontSize: "11px",
    paddingHorizontal: 30,
    paddingBottom: 100,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  logo1: {
    height: "71px",
    width: "100%",
    marginHorizontal: "auto",
  },
  content: {
    // margin: "auto",
    // width: "90%",
    marginTop: 40,
  },
  textCenter: {
    textAlign: "center",
  },
  textCenter1 :{
    textAlign: "left",
  },
  wrap: {
    wrap: true,
  },
  flex: {
    display: "flex",
    flexDirection: "row",
    //   justifyContent:'space-between'
  },
  flexRowReverse: {
    flexDirection: "row-reverse",
  },
  flexWrap: {
    flexWrap: "wrap",
  },
  marginY5: {
    marginVertical: "5px",
  },
  marginY10: {
    marginVertical: "10px",
  },
  marginT10: {
    marginVertical: "10px",
  },
  marginB10: {
    marginVertical: "10px",
  },

  // Table
  col: {
    // borderRight: "1px",
    // borderColor: "black",
    flexWrap: "wrap",
    maxWidth: "150px",
  },
  cell: {
    padding: "5px",
    borderBottom: 0.5,
    borderTop: 0.5,
    // borderLeft: 1,
    borderRight: 1,
    // borderColor: "black",
    display: "flex",
  },
  underline: {
    textDecoration: "underline",
  },
  bold: {
    fontFamily: "Helvetica-Bold",
  },
  arabicBold: {
    fontFamily: "ArabicBold",
    textAlign: "right",
    direction: "rtl",
    // textAlign: 'left'
  },
  arabic: {
    fontFamily: "Arabic",
    flexDirection: "row",
    textAlign: "right",
    writingMode: "horizontal-tb",
    direction: "rtl",
    fontSize: "9px",
  },
});

export const color = StyleSheet.create({
  bgGray: {
    backgroundColor: "gray",
  },
  bgBlack: {
    backgroundColor: "black",
  },
  textWhite: {
    color: "white",
  },
});
export const table1 = {
  table: {
    display: "flex",
    flexDirection: "row",
    // border: "1px",
    borderBottom: 1,
    // borderRight: "0px",
    width: "100%",
    fontSize: "9px",
  },
  cell: {
    padding: "2px",
    borderRight: 1,
    // borderLeft: 1,
    borderTop: 0.5,
    borderBottom: 0.5,
    // borderColor: "black",
  },
};

export const margin = StyleSheet.create({
  m0: {
    margin: "0px",
  },
  mx0: {
    marginHorizontal: "0px",
  },
  my0: {
    marginVertical: "0px",
  },
  mt0: {
    marginTop: "0px",
  },
  mb0: {
    marginBottom: "0px",
  },
  m5: {
    margin: "5px",
  },
  mx5: {
    marginHorizontal: "5px",
  },
  my5: {
    marginVertical: "5px",
  },
  mt5: {
    marginTop: "5px",
  },
  mb5: {
    marginBottom: "5px",
  },
  m8: {
    margin: "8px",
  },
  mx8: {
    marginHorizontal: "8px",
  },
  my8: {
    marginVertical: "8px",
  },
  mt8: {
    marginTop: "8px",
  },
  mb8: {
    marginBottom: "8px",
  },
  m10: {
    margin: "10px",
  },
  mx10: {
    marginHorizontal: "10px",
  },
  my10: {
    marginVertical: "10px",
  },
  mt10: {
    marginTop: "10px",
  },
  mb10: {
    marginBottom: "10px",
  },
  m12: {
    margin: "12px",
  },
  mx12: {
    marginHorizontal: "12px",
  },
  my12: {
    marginVertical: "12px",
  },
  mt12: {
    marginTop: "12px",
  },
  mb12: {
    marginBottom: "12px",
  },
  m15: {
    margin: "15px",
  },
  mx15: {
    marginHorizontal: "15px",
  },
  my15: {
    marginVertical: "15px",
  },
  mt15: {
    marginTop: "15px",
  },
  mb15: {
    marginBottom: "15px",
  },
  m20: {
    margin: "20px",
  },
  mx20: {
    marginHorizontal: "20px",
  },
  my20: {
    marginVertical: "20px",
  },
  mt20: {
    marginTop: "20px",
  },
  mb20: {
    marginBottom: "20px",
  },
});

export const border = StyleSheet.create({
  // b0: {
  //   border: "0px",
  // },
  // bt0: {
  //   borderTop: "0px",
  // },
  // br0: {
  //   borderRight: "0px",
  // },
  // bl0: {
  //   borderLeft: "0px",
  // },
  // bb0: {
  //   borderBottom: "0px",
  // },
  // b1: {
  //   border: "1px",
  // },
  // bt1: {
  //   borderTop: "1px",
  // },
  // br1: {
  //   borderRight: "1px",
  // },
  // bl1: {
  //   borderLeft: "1px",
  // },
  // bb1: {
  //   borderBottom: "1px",
  // },
});

export const pad = StyleSheet.create({
  a0: {
    padding: "0px",
  },
  x0: {
    paddingHorizontal: "0px",
  },
  y0: {
    paddingVertical: "0px",
  },
  t0: {
    paddingTop: "0px",
  },
  b0: {
    paddingBottom: "0px",
  },
  a5: {
    padding: "5px",
  },
  x5: {
    paddingHorizontal: "5px",
  },
  y5: {
    paddingVertical: "5px",
  },
  t5: {
    paddingTop: "5px",
  },
  b5: {
    paddingBottom: "5px",
  },
  a8: {
    padding: "8px",
  },
  x8: {
    paddingHorizontal: "8px",
  },
  y8: {
    paddingVertical: "8px",
  },
  t8: {
    paddingTop: "8px",
  },
  b8: {
    paddingBottom: "8px",
  },
  a10: {
    padding: "10px",
  },
  x10: {
    paddingHorizontal: "10px",
  },
  y10: {
    paddingVertical: "10px",
  },
  t10: {
    paddingTop: "10px",
  },
  b10: {
    paddingBottom: "10px",
  },
  a12: {
    padding: "12px",
  },
  x12: {
    paddingHorizontal: "12px",
  },
  y12: {
    paddingVertical: "12px",
  },
  t12: {
    paddingTop: "12px",
  },
  b12: {
    paddingBottom: "12px",
  },
  a15: {
    padding: "15px",
  },
  x15: {
    paddingHorizontal: "15px",
  },
  y15: {
    paddingVertical: "15px",
  },
  t15: {
    paddingTop: "15px",
  },
  b15: {
    paddingBottom: "15px",
  },
  a20: {
    padding: "20px",
  },
  x20: {
    paddingHorizontal: "20px",
  },
  y20: {
    paddingVertical: "20px",
  },
  t20: {
    paddingTop: "20px",
  },
  b20: {
    paddingBottom: "20px",
  },
  a25: {
    padding: "25px",
  },
  x25: {
    paddingHorizontal: "25px",
  },
  y25: {
    paddingVertical: "25px",
  },
  t25: {
    paddingTop: "25px",
  },
  b25: {
    paddingBottom: "25px",
  },

  y30: {
    paddingVertical: "30px",
  },
  y35: {
    paddingVertical: "30px",
  },
});

export const width = StyleSheet.create({
  wfull: {
    width: "min-content",
  },
});
